import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store';
import './styles/main.scss';
import App from './App';
const getRootElement = () => {
    const element = document.getElementById('root');
    if (!element)
        throw new Error('Root element with id "root" not found');
    return element;
};
const root = ReactDOM.createRoot(getRootElement());
root.render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(React.StrictMode, { children: _jsx(App, {}) }) })));
